import type { EditableGoalFields, GoalSuggestion } from "../types";

import type { PostGoalData } from "../../../api/services/defs/goals";

/** Payload for AI goal creation — overrides PostGoalData fields to match CreateGoalRequest schema. */
type GoalCreatePayload = Omit<PostGoalData, "target" | "goalWeight"> & {
	assignee: string;
	target: string;
	goalWeight: null;
};

/**
 * Transforms a GoalSuggestion (original AI values) with optional edits
 * into a payload compatible with POST /v1/goals via useMutateCreateGoal.
 */
export const transformToGoalPayload = (
	suggestion: GoalSuggestion,
	edits?: Partial<EditableGoalFields>,
	defaultTransparency?: string
): GoalCreatePayload => {
	const name = edits?.name ?? suggestion.name;
	const target = String(edits?.target !== undefined ? edits.target : suggestion.target);
	const units = edits?.units ?? suggestion.units;
	const description = suggestion.description;

	const startDate =
		edits?.startDate !== undefined
			? (edits.startDate ?? "")
			: suggestion.startDate
				? new Date(suggestion.startDate + "T00:00:00")
				: "";

	const endDate =
		edits?.endDate !== undefined
			? (edits.endDate ?? "")
			: suggestion.endDate
				? new Date(suggestion.endDate + "T00:00:00")
				: "";

	const categories =
		edits?.categories !== undefined ? edits.categories.map((c) => c._id) : suggestion.categories.map((c) => c.id);

	return {
		name,
		target,
		units,
		description,
		startDate,
		endDate,
		categories,
		assignee: edits?.assignee?.id ?? suggestion.assigneeId,
		transparency: defaultTransparency === "private" ? "private" : suggestion.transparency,
		alignment: "",
		isTopGoal: false,
		goalWeight: null,
		checklist: [],
		source: "ask-performyard",
	};
};
